import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const EmailTemplatesHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Email Templates
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Create and manage professional email templates for various stages of your hiring process.
            Maintain consistent communication with candidates while saving time on repetitive emails.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Template Types
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Access a variety of pre-built templates for different scenarios including application
            confirmations, interview invitations, offer letters, and rejection notifications.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Customization
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Customize templates with your company branding and tone. Add personalization tokens
            to automatically include candidate and job-specific information.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Template Management
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Organize and manage your email templates efficiently. Create different versions for
            various roles or departments, and update templates as needed.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Automation
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Set up automated email sequences for different stages of your hiring process.
            Ensure timely communication with candidates while reducing manual work.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/tools/templates"
              color="primary"
              variant="contained"
            >
              Manage Email Templates
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default EmailTemplatesHelp; 